import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import './index.scss';
import App from './app';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './core/redux/store';
import ThemeProvider from './core/theme/ThemeProvider';
import { GlobalStyle } from './core/theme/createGlobalStyles';
import { I18nextProvider } from 'react-i18next';

import i18n from './i18n/config';
import ToastContainer from './core/utils/view/toast';
import { enablePatches, setAutoFreeze } from 'immer';
import '@szhsin/react-menu/dist/index.css';
import numeral from 'numeral';

// import './duffDeviceTest';
import { Button } from '@chakra-ui/react';
// import { duffDeviceIteration, normalArrayIteration } from './duffDeviceTest2';
// import './testObjectIteration'
// import { testBasicDuff } from './duffDeviceTest';
// import { normalArrayIteration, duffDeviceIteration, createCells } from './duffDeviceTest2';
// import './speedTest';

// import './sheet/storage/sheetStorageManager';

// import './immerMapTest';
// import './immerTest'
// import './immerSheetTest'
// import './core/database/user/userWorkerManager'
// import './immerCellObjStruc'
// import './immerCellStructure'
// import './regexExperiments'
// import './addressMoveTest'

const Root = () => {
  enablePatches();
  setAutoFreeze(false); // This will improve performance | We have implemented custom acquire release lock system
  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider>
          <GlobalStyle rtl={false} />
          {/* <Button onClick={normalArrayIteration}>Normal Loop</Button>
          <Button onClick={duffDeviceIteration}>Duff Loop</Button> */}
          {/* <Button onClick={createCells}>Add Cells</Button> */}
          <App />
        </ThemeProvider>
      </I18nextProvider>
    </Provider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <>
    <Root />
    <ToastContainer />
  </>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
